// extracted by mini-css-extract-plugin
export default {"loading-icon":"_2v3Wf","loadingIcon":"_2v3Wf","loading-opacity":"_2Ymzj","loadingOpacity":"_2Ymzj"};